module.exports = __webpack_public_path__ + "static/media/EA_Wordmark_B_RGB.b8d4f0d7.png";